import React, { useState } from "react";
import { RadioLabelComponentWrapper } from "./styles";
import RadioComponent from "./RadioComponent";

const RadioLabelComponent = ({
  checked = false,
  state = "default",
  color = "neutral",
  labelHeader,
  labelDescription,
  onChange,
  isEditMode
}) => {
  const handleClick = () => {
    if (state === "disabled" || isEditMode) return;
    onChange();
  };

  return (
    <RadioLabelComponentWrapper
      style={{ opacity: state === "disabled" ? 0.6 : 1 }}
      checked={checked}
      labelDescription={labelDescription}
    >
      <div className="radio-btn">
        <RadioComponent
          status={checked}
          state={isEditMode ? "disabled" : state}
          color={color}
          onChange={handleClick}
        />
      </div>

      <div
        className="label-data"
        onClick={handleClick}
        style={{
          cursor: state === "disabled" || isEditMode ? "not-allowed" : "pointer"
        }}
      >
        <h4>{labelHeader}</h4>
        <p>{labelDescription}</p>
      </div>
    </RadioLabelComponentWrapper>
  );
};

export default RadioLabelComponent;
